<template>
    <!-- Generator: Adobe Illustrator 24.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
    <g>
    <polyline style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" points="30,24.9 30,29.8 25.2,29.8 		"/>
    <line style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" x1="30" y1="29.8" x2="21.9" y2="21.7"/>
    <polyline style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" points="10,14.6 10,9.8 14.8,9.8 		"/>
    <line style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" x1="10" y1="9.8" x2="18.1" y2="17.8"/>
    <polyline style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" points="14.9,29.8 10,29.8 10,24.9 		"/>
    <line style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" x1="10" y1="29.8" x2="18.1" y2="21.7"/>
    <polyline style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" points="25.1,9.8 30,9.8 30,14.6 		"/>
    <line style="fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;" x1="30" y1="9.8" x2="21.9" y2="17.8"/>
    </g>
</svg>
</template>

<script>
    export default {
        name: "IconZoom"
    }
</script>

<style scoped>

</style>